import { useState } from "react"
import { useForm, FormProvider } from "react-hook-form"
import Logo from "@/shared/components/logo"
import { SendLink } from "@/features/homeowners/api/homeowners.api"
import { Button } from "@/shared/components/ui/button"
import AuthBgWrapper from "@/features/auth/components/auth-bg-wrapper"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import { loginScreenBgImage } from "@/features/auth/constants/image"
import axios from "axios"
import successToast from "@/shared/lib/toast/success.toast"
import errorToast from "@/shared/lib/toast/error.toast"

export default function RegisterIntro() {
  const [isChecked, setIsChecked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const methods = useForm()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
  }

  const handleRegister = async () => {
    const email = methods.getValues("email")
    const role = "Volunteer"

    if (!email) {
      alert("Please enter your email")
      return
    }

    setIsLoading(true)
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BASE_BACKEND_URL || '/api'}/auth/registration/register`,
        { email, role },
        { headers: { "Content-Type": "application/json" } }
      )
      
      if (response) {
        const res = await SendLink(email)
        if (res?.success) {
          successToast("Link shared successfully on your email")
        }
      }
    } catch (error: any) {
      errorToast("Email already exist! please try another account")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthBgWrapper image={loginScreenBgImage}>
      <div className="flex flex-col md:flex-row items-center justify-center min-h-screen px-4 gap-8 md:gap-16 lg:gap-28">
        
        {/* Left Section */}
        <div className="w-full max-w-lg bg-white shadow-lg rounded-2xl p-6 flex flex-col gap-6 text-center md:text-left">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">Welcome!</h2>
          <p className="text-gray-600 text-sm md:text-base">
            We’re so grateful you’ve joined this community of people bringing hope and restoration where it’s needed most.
          </p>
          <p className="text-gray-700 text-sm md:text-base font-medium">
            By creating your account, you’re taking an intentional first step in disaster relief and recovery work that changes lives.
          </p>
        </div>

        {/* Right Section */}
        <div className="w-full max-w-md bg-white my-6 py-8 px-5 md:px-8 rounded-2xl flex flex-col items-center gap-6 shadow-xl transition-transform duration-300 hover:scale-[1.01]">
          <Logo className="w-28 sm:w-36 md:w-44" />
          <div className="text-center space-y-2">
            <p className="text-gray-800 text-lg font-semibold">Create your Account</p>
            <p className="text-gray-700 text-sm md:text-base">
              Input your email below and check out the latest status where hope is being restored!
            </p>
          </div>

          <FormProvider {...methods}>
            <form className="flex flex-col gap-4 w-full">
              <FormTextInput
                inputGroupProps={{ label: "Email Address" }}
                type="email"
                placeholder="Enter your email"
                name="email"
                control={methods.control}
              />
            </form>
          </FormProvider>

          <Button
            onClick={handleRegister}
            disabled={isLoading}
            className="w-full py-3 md:py-4 text-sm md:text-base font-medium rounded-xl shadow-md transition text-center whitespace-normal"
          >
            {isLoading ? "Registering..." : "Register Now"}
          </Button>
        </div>
      </div>
    </AuthBgWrapper>
  )
}
